import React, { Component } from "react"
import { connect } from "react-redux"
import { Link } from "react-router"
import logo from "../EFLogoSm.png"

export class Header extends Component {
  renderLinks() {
    if (this.props.authenticated) {
      return (
        <div className="foo">
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="supportedContentDropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Events
            </a>
            <div
              className="dropdown-menu"
              aria-labelledby="supportedContentDropdown"
            >
              <Link className="dropdown-item" to={"/events/new"}>
                New Event
              </Link>
              <Link className="dropdown-item" to={"/events"}>
                List Events
              </Link>
            </div>
          </li>
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="supportedContentDropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Venues
            </a>
            <div
              className="dropdown-menu"
              aria-labelledby="supportedContentDropdown"
            >
              <Link className="dropdown-item" to={"/venues/new"}>
                New Venue
              </Link>
              <Link className="dropdown-item" to={"/venues"}>
                List Venues
              </Link>
            </div>
          </li>

          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="supportedContentDropdown"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Notifications
            </a>
            <div
              className="dropdown-menu"
              aria-labelledby="supportedContentDropdown"
            >
              <Link className="dropdown-item" to={"/notifications/new"}>
                New Notification
              </Link>
              <Link className="dropdown-item" to={"/notifications"}>
                List Notifications
              </Link>
            </div>
          </li>

          <li className="nav-item">
            <a
              className="nav-link"
              target="_blank"
              href={
                "https://www.google.com/analytics/web/template?uid=XQjjwtH2Ry20yKT7agq--g"
              }
            >
              Analytics
            </a>
          </li>
          <li className="nav-item float-xs-right">
            <Link className="nav-link" to={"/signout"}>
              Sign Out
            </Link>
          </li>
        </div>
      )
    } else {
      return (
        <div className="foo">
          <li className="nav-item">
            <Link className="nav-link" to="/signin">
              Sign In
            </Link>
          </li>
        </div>
      )
    }
  }

  render() {
    return (
      <nav
        className="navbar navbar-dark"
        style={{ backgroundColor: "#942280" }}
      >
        <Link to="/" className="navbar-brand">
          <img src={logo} alt="EF Logo" />
        </Link>
        <ul className="nav navbar-nav">
          {this.renderLinks()}
        </ul>
      </nav>
    )
  }
}

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated
  }
}

export default connect(mapStateToProps)(Header)



/** WEBPACK FOOTER **
 ** ./src/components/header.js
 **/